import { render, staticRenderFns } from "./Selects.vue?vue&type=template&id=025e2bcb&scoped=true&"
import script from "./Selects.vue?vue&type=script&lang=js&"
export * from "./Selects.vue?vue&type=script&lang=js&"
import style0 from "./Selects.vue?vue&type=style&index=0&id=025e2bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e2bcb",
  null
  
)

export default component.exports